import React from "react";
import {
  CalendarDays,
  MapPin,
  Star,
  BookOpen,
  Globe,
  Twitter,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

export function OverviewSection() {
  return (
    <div className="grid md:flex gap-8">
      <div className="md:col-span-2 space-y-6">
        {/* Heading */}
        <h2 className="text-3xl font-semibold text-black flex items-center gap-2">
          {/* <Star className="w-6 h-6 text-blue-500" /> */}
          Overview
        </h2>

        {/* Description */}
        <p className="text-pretty text-gray-700 leading-relaxed">
          <span className="font-semibold text-blue-400">BioMANTHAN 2025</span> is the 40th International Conference
          organized by <span className="font-medium">SBAOI &amp; STERMI</span> at IIT Ropar, Punjab, India. The program
          spans Biomaterials, 3D Bioprinting, Biomedical Implants, Biomechanics, Bioimaging, Radiology, and more, with a
          special focus session on <span className="font-semibold text-blue-400">3D Printing</span>.
        </p>

        {/* Info Cards */}
        <div className="grid gap-4 md:grid-cols-2">
          {/* Dates & Location */}
          <div className="rounded-xl border border-blue-200 bg-blue-50/30 p-4 hover:shadow-md transition-all">
            <h3 className="font-medium flex items-center gap-2 text-blue-500">
              <CalendarDays className="w-5 h-5" />
              Dates & Location
            </h3>
            <p className="text-sm text-gray-600 mt-1 flex items-center gap-1">
              <MapPin className="w-4 h-4 text-blue-500" />
              Dec’ 4–7, 2025 • Chandigarh, Punjab
            </p>
          </div>

          {/* Highlights */}
          <div className="rounded-xl border border-blue-200 bg-blue-50/30 p-4 hover:shadow-md transition-all">
            <h3 className="font-medium flex items-center gap-2 text-blue-500">
              <BookOpen className="w-5 h-5" />
              Highlights
            </h3>
            <ul className="text-sm text-gray-600 space-y-1 mt-2">
              <li>• Plenary & Keynote Lectures</li>
              <li>• Hands-on Training & Workshop Sessions (Dec’ 3, 2025)</li>
              <li>• Publish in 5+ peer-reviewed international journals</li>
            </ul>
          </div>
        </div>

        {/* Key Links */}
        <div className="rounded-xl border border-blue-200 bg-blue-50/30 p-4 hover:shadow-md transition-all">
          <h3 className="font-medium flex items-center gap-2 text-black">
            <Globe className="w-5 h-5" />
            Key Links
          </h3>
          <ul className="text-sm text-gray-600 grid gap-2 mt-2">
            <li>
              <a
                className="flex items-center gap-2 text-black underline underline-offset-4 transition-colors"
                href="http://www.iitrpr.ac.in/biomanthan/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Globe className="w-4 h-4" /> Official Website
              </a>
            </li>
            <li>
              <a
                className="flex items-center gap-2 text-black underline underline-offset-4 transition-colors"
                href="https://twitter.com/iitrpr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter className="w-4 h-4 text-sky-500" /> Twitter
              </a>
            </li>
            <li>
              <a
                className="flex items-center gap-2 text-black underline underline-offset-4 transition-colors"
                href="https://www.facebook.com/iitrpr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook className="text-blue-700 w-4 h-4" /> Facebook
              </a>
            </li>
            <li>
              <a
                className="flex items-center gap-2 text-black underline underline-offset-4 transition-colors"
                href="https://www.instagram.com/iit_ropar_official/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="text-pink-500 w-4 h-4" /> Instagram
              </a>
            </li>
            <li>
              <a
                className="flex items-center gap-2 text-black underline underline-offset-4 transition-colors"
                href="https://www.linkedin.com/company/108687393/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin className="text-blue-500 w-4 h-4" /> LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
